/* File: frontend/src/services/consiliumBridge.js */
/* Version: v1.0 (260907-ho7 — вопрос без дела) */
/* Description:
   Переносит текст вопроса из виджета Катифи на страницу консилиума.

   🔴 Текст переносится КАК ЕСТЬ. Ни trim(), ни slice(), ни шаблонов: вопрос,
   доехавший в изменённом виде, — это уже другой вопрос, а адвокат увидит своё
   формулирование и не заметит подмены. Краевые пробелы и переводы строк
   сохраняются намеренно.

   Хранилище передаётся параметром, чтобы перенос можно было прогнать НАСТОЯЩИМ
   исполнением вне браузера, а не проверять чтением исходника.
*/

export const CONSILIUM_QUESTION_KEY = 'katifi_consilium_question';

/* 🔴 Событие существует потому, что виджет висит на КАЖДОЙ странице, включая
   саму /ai-paralegal. Нажатие кнопки, когда человек уже на этой странице,
   делает navigate() пустой операцией: страница не перемонтируется, эффект
   монтирования уже отработал, и вопрос остаётся лежать в хранилище. Всплыл бы
   он при СЛЕДУЮЩЕМ заходе — и выглядел бы новым вопросом, которого никто не
   задавал. Событие делает подстановку не зависящей от перемонтирования. */
export const CONSILIUM_QUESTION_EVENT = 'katifi:consilium-question';

const defaultStorage = (storage) =>
  storage || (typeof window !== 'undefined' ? window.sessionStorage : null);

export function putQuestion(text, storage) {
  const s = defaultStorage(storage);
  if (!s) return false;
  s.setItem(CONSILIUM_QUESTION_KEY, String(text));
  /* Вне браузера (сторож гоняет мост настоящим исполнением в node) окна нет —
     перенос обязан работать и без события. */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(new CustomEvent(CONSILIUM_QUESTION_EVENT));
  }
  return true;
}

export function takeQuestion(storage) {
  const s = defaultStorage(storage);
  if (!s) return null;
  const v = s.getItem(CONSILIUM_QUESTION_KEY);
  /* Забрали — значит забрали: ключ снимается, иначе тот же вопрос подставится
     при следующем заходе на страницу и будет выглядеть новым. */
  if (v !== null) s.removeItem(CONSILIUM_QUESTION_KEY);
  return v;
}
